import React, { useEffect } from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import { useTranslation, Trans } from 'react-i18next'
// import Loading from '../components/Loading'
import { useImageTranslation } from 'src/hooks'
import { Box, Button, useMediaQuery, useTheme, CardHeader, Tab } from '@material-ui/core'
import TabContext from '@material-ui/lab/TabContext'
import TabList from '@material-ui/lab/TabList'
import TabPanel from '@material-ui/lab/TabPanel'
import { ReactComponent as Return } from '../assets/icons/Return.svg'
import { ReactComponent as ToOrder } from 'src/mobile/assets/icons/Home_all.svg'
import { ReactComponent as Checked } from '../assets/icons/checked.svg'
import { ReactComponent as Copy } from '../mobile/assets/icons/copy.svg'
import ProductSwiperMobile from 'src/mobile/components/Homepage/ProductSroll'
import ProductSwiperPC from 'src/mobile/components/Homepage/ProductSrollDetails'
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined'
import { setSelectedDoctor } from 'src/store/slices/testCenterSlice'
import TopStickyBar from 'src/mobile/layout/TopStickyBar'
import SnackbarHelperText from 'src/mobile/components/SnackbarHelperText'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { PROMOTION_CODE, productCardData } from 'src/utils/constant'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { getFaqList } from 'src/store/slices/docSlice'
import { useHistory, Link, useRouteMatch } from 'react-router-dom'
import BookingInfo from 'src/components/BookingInfo'
import EDrawer from 'src/mobile/themes/components/EDrawer'
import { Helmet  } from 'react-helmet'
import { addToCart, buttonClick, viewItem } from 'src/utils/trackingCode'

import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined'
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      textAlign: 'justify',
      '& sup': {
        fontSize: '10px',
      },
      marginTop: -8,
      backgroundColor: '#fff',
    },
    tabList: {
      '& .MuiTabs-indicator': {
        backgroundColor: '#F2512D',
      },
      '& .MuiTab-wrapper': {
        fontWeight: 600,
      },
      borderBottom: '1px solid #E5E7EB',
    },
    viewAllbtnIcon: {
      marginLeft: 4,
    },
    back: {
      margin: '24px',
      borderRadius: '100px',
      // width: '105px',
      height: '56px',
      fontSize: 16,
      [theme.breakpoints.down('xs')]: {
        // width: '81px',
        height: '40px',
        fontSize: 14,
      },
    },
    tab: {
      marginTop: '64px',
      backgroundColor: theme.palette.background.paper,
      [theme.breakpoints.down('xs')]: {
        marginTop: 0,
      },
      '& .MuiTab-wrapper': {
        fontSize: 16,
      },
    },
    flexContainer: {
      [theme.breakpoints.down('xs')]: {
        justifyContent: 'space-around',
      },
    },
    bannerWrapper: {
      marginTop: -100,
      [theme.breakpoints.down('xs')]: {
        height: theme.spacing(33.125),
      },
      display: 'grid',
      position: 'relative',
    },
    titleWrapper: {
      gridArea: '1/1',
      display: 'grid',
      height: '100%',
      position: 'relative',
      flexDirection: 'column',
    },
    breakTitle: {
      wordBreak: 'keep-all',
      whiteSpace: 'break-spaces',
    },
    banner: {
      display: 'block',
      position: 'relative',
      width: '100%',
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    cardHeader: {
      paddingTop: 16,
      paddingBottom: 8,
    },
    productAvtar: {
      borderRadius: 8,
      display: 'block',
      height: '420px',
      width: 630,
      marginLeft: '20px',
      [theme.breakpoints.down('xs')]: {
        width: '90%',
        margin: '8px auto',
        background: '#Fff',
        height: 'auto',
      },
    },

    tableImg: {
      width: '100%',
      maxWidth: theme.spacing(98),
    },
    checkIcon: {
      width: theme.spacing(5),
      height: theme.spacing(5),
      [theme.breakpoints.down('xs')]: {
        minWidth: theme.spacing(3),
        height: theme.spacing(3),
      },
    },
    button: {
      height: '56px',
      fontSize: '18px',
      maxWidth: '294px',
      fontWeight: 700,
      marginLeft: 20,
      [theme.breakpoints.down('xs')]: {
        width: '300px',
        marginLeft: 0,
        marginTop: '20px',
        fontSize: '18px',
        height: '56px',
      },
    },
    HealthCheckImg: {
      marginTop: '24px',
      marginBottom: '24px',
    },
    hoverstyle: {
      cursor: 'pointer',
    },
  }),
)

const ProductInfo = () => {
  const { t, i18n } = useTranslation()
  const classes = useStyles({ language: i18n.language })
  const dispatch = useDispatch()
  const [tImage] = useImageTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const history = useHistory()
  const isStandard = useRouteMatch(`/${i18n.language}/product-standard-health-check-package`)
  const isFemale = useRouteMatch(`/${i18n.language}/product-female-health-check-package`)
  const isMale = useRouteMatch(`/${i18n.language}/product-male-health-check-package`)

  console.log(isStandard, isFemale, isMale)
  useEffect(async () => {
    document.getElementById('return').scrollIntoView()
    dispatch(getFaqList({ faqIds: [14, 17, 34, 33, 27, 26] }))
  }, [])
  const [value, setValue] = React.useState('1')
  const [modal, setModal] = React.useState(false)

  const getPageName = (type) => {
    const page = isStandard ? 3 : isFemale ? 5 : 4
    const productDetail = {
      5: 'EH_FemaleHealthCheckPage_Details_Tab',
      4: 'EH_MaleHealthCheckPage_Details_Tab',
      3: 'EH_BasicHealthCheckPage_Details_Tab',
    }
    const bookingInfo = {
      5: 'EH_FemaleHealthCheckPage_Reminders_Tab',
      4: 'EH_MaleHealthCheckPage_Reminders_Tab',
      3: 'EH_BasicHealthCheckPage_Reminders_Tab',
    }
    const buttonName = type === '1' ? productDetail[page] : bookingInfo[page]
    buttonClick(buttonName, buttonName)
  }
  const handleChangeTab = (event, newValue) => {
    getPageName(newValue)
    setValue(newValue)
  }

  const checkAllClick = () => {
    const checkAll = {
      5: 'EH_FemaleHealthCheckPage_CheckAll',
      4: 'EH_MaleHealthCheckPage_CheckAll',
      3: 'EH_BasicHealthCheckPage_CheckAll',
    }
    const page = isStandard ? 3 : isFemale ? 5 : 4
    buttonClick(checkAll[page], checkAll[page])
  }

  const commonFAQClick = () => {
    const commonFAQ = {
      5: 'EH_FemaleHealthCheckPage_FAQ',
      4: 'EH_MaleHealthCheckPage_FAQ',
      3: 'EH_BasicHealthCheckPage_FAQ',
    }
    const page = isStandard ? 3 : isFemale ? 5 : 4
    buttonClick(commonFAQ[page], commonFAQ[page])
  }
  const ItemDot = () => (
    <Box color="grey.900" mr={1} component="span" fontWeight={800}>
      •
    </Box>
  )
  const conference = [
    {
      item: 'Chan, K. C. Allen, et al. “Analysis of Plasma Epstein–Barr Virus DNA to Screen for Nasopharyngeal Cancer.” New England Journal of Medicine, vol. 377, no. 6, 2017, pp. 513–22.',
    },
    {
      item: 'Lam, W. K. Jacky, et al. “Sequencing-Based Counting and Size Profiling of Plasma Epstein–Barr Virus DNA Enhance Population Screening of Nasopharyngeal Carcinoma.” Proceedings of the National Academy of Sciences, vol. 115, no. 22, 2018, pp. E5115–24.',
    },
  ]
  const greenCheck = [
    {
      intro: t('productPage.NPC.special.1'),
    },
    {
      intro: (
        <Trans i18nKey="productPage.NPC.special.2">
          .<sup>4,5</sup>.<sup>5</sup>
        </Trans>
      ),
    },
    {
      intro: t('productPage.NPC.special.3'),
    },
    {
      intro: (
        <Trans i18nKey="productPage.NPC.special.4">
          .<sup>4,5</sup>.<sup>5</sup>
        </Trans>
      ),
    },
    {
      intro: t('productPage.NPC.special.5'),
    },
    {
      intro: t('productPage.NPC.special.6'),
    },
  ]
  const program = [
    {
      title: t('productPage.cbc'),
      function: [
        { name: t('check_program.hb') },
        { name: t('check_program.hct') },
        { name: t('check_program.plt') },
        { name: t('check_program.wbc') },
        { name: t('check_program.rbc') },
        { name: t('check_program.mcv') },
        { name: t('check_program.mcn') },
        { name: t('check_program.mchc') },
        { name: t('check_program.wbcc') },
      ],
    },
    {
      title: t('productPage.liver_function'),
      function: [
        { name: t('check_program.total_bilo') },
        { name: t('check_program.direct_bili') },
        { name: t('check_program.ast') },
        { name: t('check_program.alt') },
        { name: t('check_program.ggt') },
        { name: t('check_program.alp') },
        { name: t('check_program.total_protein') },
        { name: t('check_program.albumin') },
        { name: t('check_program.globulin') },
      ],
    },
    {
      title: t('productPage.renal_function'),
      function: [
        { name: t('check_program.urea') },
        { name: t('check_program.creatinine') },
        { name: t('check_program.sodium') },
        { name: t('check_program.potass') },
        { name: t('check_program.chlor') },
        { name: t('check_program.bicarbonate') },
        { name: t('check_program.egfr') },
      ],
    },
    {
      title: t('productPage.diabetes_screening'),
      function: [{ name: t('check_program.fast_glucose') }],
    },
    {
      title: t('productPage.blood_lipids'),
      function: [
        { name: t('check_program.cholesterol') },
        { name: t('check_program.hdl') },
        { name: t('check_program.ldl') },
        { name: t('check_program.triglycerides') },
      ],
    },
    {
      title: t('productPage.thyroid_assessment'),
      function: [{ name: t('check_program.tsh') }, { name: t('check_program.T4') }],
    },
    {
      title: t('productPage.Cardiovascular Function Assessment'),
      function: [{ name: t('check_program.ecg') }],
    },
    {
      title: t('productPage.chest'),
      function: [{ name: t('check_program.x-ray') }],
    },
    {
      title: t('productPage.report_explain'),
      function: [{ name: t('check_program.register_expalin') }],
    },
  ]

  const getItems = () => {
    const page = isStandard ? '3' : isFemale ? '5' : '4'
    const data = productCardData.filter((ele) => ele.package === page)
    const items =
      data.length > 0 &&
      data.map((ele) => ({
        item_id: ele.id,
        item_name: ele.nameHK,
        index: ele.index,
        price: ele.price,
      }))
    return items.length > 0 ? items : []
  }

  const addTrackingCode = (item) => {
    const ecommerce = {
      currency: 'HKD',
      value: isStandard ? '4000' : '4300',
      items: [item]
    }
    addToCart(ecommerce)
  }


  useEffect(()=>{
    const ecommerce = {
      currency: 'HKD',
      value: isStandard ? '4000' : '4300',
      items: getItems(),
    }
    viewItem(ecommerce)
  },[])

  return (
    <Box className={classes.root}>
      <Helmet>
        <meta 
          name="description" 
          content={
            isStandard 
                  ? t('seoDescription.basicHealthCheck') 
                  : isMale
                  ? t('seoDescription.maleHealthCheck')
                  : t('seoDescription.femaleHealthCheck')
          } 
        />
        <title>
           {isStandard
                  ? t('seoTitle.basicHealthCheck')
                  : isMale
                  ? t('seoTitle.MaleHealthCheck')
                  : t('seoTitle.FemaleHealthCheck')
           }
        </title>
      </Helmet>
      <TopStickyBar>
        <SnackbarHelperText>
          <CardHeader
            classes={{
              root: classes.cardHeader,
              avatar: classes.cardHeaderAvatar,
            }}
            title={
              <Box alignItems="center" display="flex" fontWeight="400">
                <Box fontSize="h5.fontSize" component="span" mr={3} flexShrink="0" width="90%">
                  <Box fontSize="body1.fontSize">
                    {t('glossary.promotion.first_time_sign_up_get_discount', { field: PROMOTION_CODE })}
                  </Box>
                </Box>
                <CopyToClipboard
                  text={PROMOTION_CODE}
                  onCopy={() => {
                    toast.success(t('toast.promo_code_copy_success'))
                    buttonClick('EH_PromoCode_Copy', 'EH_PromoCode_Copy')
                  }}
                  className={classes.hoverstyle}
                >
                  <Box borderRadius={20} height={20} alignItems="center" justifyContent="center">
                    <Copy />
                  </Box>
                </CopyToClipboard>
              </Box>
            }
            disableTypography
          />
        </SnackbarHelperText>
      </TopStickyBar>
      <Box>
        <Box>
          <Button
            variant="outlined"
            className={classes.back}
            component={Link}
            onClick={() => history.push('/ProductList')}
            id="return"
          >
            <Return />
            <Box mr={0.5}>{t('glossary.product_list')}</Box>
          </Button>
        </Box>
        <Box
          bgcolor="#fff"
          display="flex"
          flexDirection={isMobile ? 'column' : 'row'}
          justifyContent="space-evenly"
        >
          <img
            width="100%"
            className={classes.productAvtar}
            src={
              isStandard
                ? tImage('health_check_3x2', 'webp')
                : isMale
                ? tImage('health_check_male_3x2', 'webp')
                : isFemale
                ? tImage('health_check_female_3x2', 'webp')
                : ''
            }
            alt="product_health_check_img1"
          />
          <Box>
            <Box className={classes.title}>
              <Box
                fontSize={isMobile ? 20 : 32}
                color="primary.main"
                fontWeight={700}
                className={classes.breakTitle}
                ml={2.5}
                textAlign="left"
              >
                {isStandard
                  ? t('form.physical_examination_basic')
                  : isMale
                  ? t('glossary.physical_examination_male')
                  : t('glossary.physical_examination_female')}
              </Box>
            </Box>
            <Box
              fontSize={isMobile ? 18 : 26}
              fontWeight={700}
              my={isMobile ? 1 : 3}
              color="secondary.main"
              ml={2.5}
            >
              {isStandard ? 'HKD4,000' : 'HKD4,300'}
            </Box>

            <Box
              fontSize={16}
              fontWeight={400}
              maxWidth="600px"
              lineHeight={1.5}
              wordBreak="break-word"
              color="grey.700"
              mx={2.5}
            >
              {t('productPage.health_check.intro')}
            </Box>
            {!isMobile && (
              <Box mt={3} display="flex" justifyContent={isMobile ? 'center' : ''} mb={3}>
                <Button
                  variant="contained"
                  fullWidth
                  size="large"
                  color="secondary"
                  className={classes.button}
                  id="EH_ProductPage_Prophecy_Book_Button1"
                  onClick={() => {
                    dispatch(
                      setSelectedDoctor({
                        package: isStandard ? 3 : isFemale ? 5 : 4,
                        price: isStandard ? '4000' : '4300',
                        currency: 'HKD',
                      }),
                    )
                    const items = getItems()
                    if (items.length > 0) {
                      addTrackingCode(items[0])
                      // selectItem('product_list', 'Product List', items[0], items[0]?.index)
                    }
                    if (isMobile) {
                      history.push(`/${i18n.language}/clinic/`, {
                        tab: isStandard ? 3 : isFemale ? 5 : 4,
                        price: isStandard ? '4000' : '4300',
                        currency: 'HKD',
                      })
                    } else {
                      history.push(`/${i18n.language}/clinic/`, {
                        tab: isStandard ? 3 : isFemale ? 5 : 4,
                        price: isStandard ? '4000' : '4300',
                        currency: 'HKD',
                      })
                    }
                  }}
                >
                  <Box>{t('glossary.book_now')}</Box>
                  {isMobile ? '' : <ToOrder className={classes.viewAllbtnIcon} />}
                </Button>
              </Box>
            )}
            {isMobile && (
              <Box
                p={1}
                bgcolor="#ffff"
                display="flex"
                justifyContent={isMobile ? 'center' : ''}
                position="fixed"
                bottom={0}
                zIndex="1209"
                width="100%"
              >
                <Button
                  variant="contained"
                  fullWidth
                  size="large"
                  color="secondary"
                  // className={classes.button}
                  style={{ height: 56, width: '100%' }}
                  id="EH_ProductPage_Prophecy_Book_Button1"
                  onClick={() => {
                    dispatch(
                      setSelectedDoctor({
                        package: isStandard ? 3 : isFemale ? 5 : 4,
                        price: isStandard ? '4000' : '4300',
                        currency: 'HKD',
                      }),
                    )
                    const items = getItems()
                    if (items.length > 0) {
                      addTrackingCode(items[0])
                      // selectItem('product_list', 'Product List', items[0], items[0]?.index)
                    }
                    if (isMobile) {
                      history.push(`/${i18n.language}/clinic/`, {
                        tab: isStandard ? 3 : isFemale ? 5 : 4,
                        price: isStandard ? '4000' : '4300',
                        currency: 'HKD',
                      })
                    } else {
                      history.push(`/${i18n.language}/clinic/`, {
                        tab: isStandard ? 3 : isFemale ? 5 : 4,
                        price: isStandard ? '4000' : '4300',
                        currency: 'HKD',
                      })
                    }
                  }}
                >
                  <Box>{t('glossary.book_now')}</Box>
                  {isMobile ? '' : <ToOrder className={classes.viewAllbtnIcon} />}
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      </Box>{' '}
      <Box className={classes.tab}>
        <TabContext value={value}>
          <TabList
            onChange={handleChangeTab}
            aria-label="lab API tabs example"
            classes={{ flexContainer: classes.flexContainer }}
            centered
            className={classes.tabList}
          >
            <Tab label={t('productPage.NPC.detail')} value="1" />
            <Tab label={t('productPage.NPC.booking_info')} value="2" />
          </TabList>

          <TabPanel value="1">
            {isMobile ? (
              ''
            ) : (
              <Box
                // width="100%"
                borderBottom="1px solid #E5E7EB"
                mb={3}
                ml={13.25}
                mr={13.25}
              >
                {!isMobile ? (
                  <Box fontWeight={600} fontSize={23} lineHeight="150%" mb={5} mt={2}>
                    {t('promotion.AllHealthCheck')}
                  </Box>
                ) : (
                  ''
                )}

                <img
                  width="100%"
                  src={
                    isStandard
                      ? tImage('productHealthCheckPackage1_all', 'webp')
                      : isMale
                      ? tImage('productHealthCheckPackage1_male', 'webp')
                      : tImage('productHealthCheckPackage1', 'webp')
                  }
                  alt="product_health_check_img1"
                />
                <img
                  width="100%"
                  className={classes.HealthCheckImg}
                  src={
                    isStandard
                      ? tImage('productHealthCheckPackage2_all', 'webp')
                      : isMale
                      ? tImage('productHealthCheckPackage2_male', 'webp')
                      : tImage('productHealthCheckPackage2', 'webp')
                  }
                  alt="product_health_check_img2"
                />
              </Box>
            )}
            <Box maxWidth={855} margin="0 auto">
              <Box fontWeight={900} fontSize={isMobile ? 20 : 23} mx={1}>
                {t('form.health_check.anchor.2')}
              </Box>
              <Box color="secondary.main" fontSize={isMobile ? 16 : 18} fontWeight={600} ml={1} mt={2}>
                {isMobile
                  ? t('productPage.health_check.year_check')
                  : t('productPage.health_check.year_check_PC')}
              </Box>
              <Box fontSize={16} fontWeight={400} ml={1} mt={2} color="grey.800">
                {t('productPage.health_check.table_intro')}
              </Box>
              <Box>
                {isMobile ? (
                  <Button
                    variant="outlined"
                    fullWidth
                    style={{ borderRadius: '100px', height: '56px', marginTop: '24px' }}
                    onClick={() => {
                      setModal(1)
                      checkAllClick()
                    }}
                  >
                    <SearchOutlinedIcon />
                    {t('productPage.health_check.check_all_packages')}
                  </Button>
                ) : (
                  ''
                )}
                <Box display="flex" flexDirection="column" mt={1} maxWidth={855}>
                  <Box fontSize={20} fontWeight={600} textAlign="left" mt={4} mb={2}>
                    {t('productPage.anchor.6')}
                  </Box>
                  <Box fontSize={16} fontWeight={600} mb={1}>
                    {t('productPage.service_type.1')}
                  </Box>
                  {greenCheck.map((item, index) => (
                    <Box display="flex" key={index} alignItems="center" my={1.5}>
                      <Box>
                        <Checked className={classes.checkIcon} />
                      </Box>
                      <Box fontSize={16} fontWeight={400} mx={1} textAlign="left">
                        {item.intro}
                      </Box>
                    </Box>
                  ))}
                  <Box fontSize={16} fontWeight={600} my={2}>
                    {t('productPage.service_type_special.2')}
                  </Box>{' '}
                  <Box fontSize={16} fontWeight={600} my={2}>
                    {t('productPage.service_type_special.3')}
                  </Box>{' '}
                  {/* <img
                    width="auto"
                    className={classes.HealthCheckImg}
                    src={tImage('product_detail_img', 'webp')}
                    alt="product_health_check_img2"
                  /> */}
                </Box>
              </Box>
            </Box>
          </TabPanel>
          <TabPanel value="2">
            <BookingInfo product={Number(isStandard ? 3 : isFemale ? 5 : 4)} />
          </TabPanel>
        </TabContext>
      </Box>
      <Box bgcolor="#fff">
        <Box
          bgcolor="#F9FAFB"
          pt={isMobile ? 2 : 8}
          pl={isMobile ? 0 : 13}
          pr={isMobile ? 0 : 13}
          pb={isMobile ? 2 : 8}
        >
          <Box fontSize="20px" color="#111827" lineHeight="150%" mt={2}>
            <Box fontWeight="fontWeightBold" component="span" ml={isMobile ? 3 : 0}>
              {t('productPage.NPC.related_pro')}
            </Box>
          </Box>
          <Box ml={isMobile ? 2 : 0} pb={isMobile ? 2 : 0}>
            {isMobile ? (
              <ProductSwiperMobile data={Number(isStandard ? 3 : isFemale ? 5 : 4)} />
            ) : (
              <ProductSwiperPC data={Number(isStandard ? 3 : isFemale ? 5 : 4)} />
            )}
          </Box>
        </Box>
        <Box textAlign="center" mb={5} mt={2}>
          <Button
            variant="outlined"
            fullWidth
            size="large"
            className={classes.button}
            component={Link}
            to="/faq"
            onClick={commonFAQClick}
          >
            <HelpOutlineOutlinedIcon /> {t('productPage.anchor.4')}
          </Button>
        </Box>
        <Box py={2} ml={isMobile ? 0 : 13.25} mr={isMobile ? 0 : 13.25}>
          <Box color="#979797" px={isMobile ? 3 : 1}>
            {t('productPage.renfrence')}
          </Box>
          {conference.map((x, index) => (
            <Box
              key={index}
              fontSize="12px"
              lineHeight={1.5}
              color="#979797"
              px={isMobile ? 3 : 1}
              textAlign="left"
              display="flex"
            >
              <Box pr={1}>{index + 1}.</Box>
              <Box dangerouslySetInnerHTML={{ __html: x.item }} textAlign="left" />
            </Box>
          ))}
        </Box>
      </Box>
      <EDrawer
        open={modal}
        onClose={() => setModal(false)}
        title={
          isStandard
            ? t('form.physical_examination_basic')
            : isMale
            ? t('glossary.physical_examination_male')
            : t('glossary.physical_examination_female')
        }
      >
        <Box my={2} fontSize={14}>
          {t('productPage.all_program')}
        </Box>
        <Box>
          <Box
            fontSize={16}
            fontWeight={600}
            bgcolor="#F9FAFB"
            height={40}
            display="flex"
            alignItems="center"
            pl={2}
          >
            {t('productPage.cancer_check')}
          </Box>
          <Box fontSize={16} fontWeight={600} display="flex" pl={2} py={1} borderBottom="1px solid #E5E7EB">
            <Box fontSize={14} fontWeight={400} textAlign="left" display="flex">
              <ItemDot /> {t('glossary.prophecy')}
            </Box>
          </Box>
          {isMale && (
            <Box fontSize={16} fontWeight={600} display="flex" pl={2} py={1} borderBottom="1px solid #E5E7EB">
              <Box fontSize={14} fontWeight={400} textAlign="left" display="flex">
                <ItemDot /> {t('check_program.psa')}
              </Box>
            </Box>
          )}
          {isFemale && (
            <Box fontSize={16} fontWeight={600} display="flex" pl={2} py={1} borderBottom="1px solid #E5E7EB">
              <Box fontSize={14} fontWeight={400} textAlign="left" display="flex">
                <ItemDot /> {t('check_program.pap')}{' '}
              </Box>
            </Box>
          )}
          {program?.map((item, index) => (
            <Box key={index}>
              <Box
                fontSize={16}
                fontWeight={600}
                bgcolor="#F9FAFB"
                height={40}
                display="flex"
                alignItems="center"
                pl={2}
              >
                {item.title}
              </Box>
              {item.function?.map((x, index2) => (
                <Box
                  fontSize={16}
                  fontWeight={600}
                  display="flex"
                  pl={2}
                  py={1}
                  key={index2}
                  borderBottom="1px solid #E5E7EB"
                >
                  <Box fontSize={14} fontWeight={400} textAlign="left" lineHeight={1.5} display="flex">
                    <ItemDot /> {x.name}
                  </Box>
                </Box>
              ))}
            </Box>
          ))}
        </Box>
      </EDrawer>
    </Box>
  )
}

export default ProductInfo
